import { Link } from "react-router";

import type { EchoflicksVideoSession } from "../types";
import { derivativeParentId, sessionShowPath } from "./renderCosts";

const DERIVATIVE_NOUNS: Record<string, string> = {
  customer_edit: "an edit",
  remake: "a remake",
  storyboard_remake: "a remake",
  operator_recut: "a re-cut",
  recut: "a re-cut",
  redelivery: "a redelivery",
};

/**
 * On a child Echo (an edit, re-cut, redelivery or a remake's ledger): which
 * Echo it derives from, and that its cost is counted in that Echo's renders,
 * so nobody adds the two pages up.
 */
export const DerivativeEchoBanner = ({
  session,
}: {
  session: EchoflicksVideoSession;
}) => {
  const parent = derivativeParentId(session);
  if (!parent) return null;
  const noun = DERIVATIVE_NOUNS[session.derivative_kind ?? ""] ?? "an edit";
  return (
    <div
      className="rounded-md border border-sky-200 bg-sky-50 p-3 text-sm text-sky-900 dark:border-sky-800 dark:bg-sky-950 dark:text-sky-100"
      data-testid="derivative-echo-banner"
    >
      {`This is ${noun} of `}
      <Link
        to={sessionShowPath(parent)}
        className="font-medium underline underline-offset-2"
      >
        {parent}
      </Link>
      ; its cost is included in that Echo&apos;s renders.
    </div>
  );
};
